import script from "./WxBinDing.vue?vue&type=script&setup=true&lang=js"
export * from "./WxBinDing.vue?vue&type=script&setup=true&lang=js"
script.__scopeId = "data-v-0352b2d3"

export default script